import React, { FunctionComponent } from 'react'

import '../styles/MatchingTerms.scss'

interface Props {
  backgroundColor: string
  terms: string[]
}

const MatchingTerms: FunctionComponent<Props> = (props) => {
  const { backgroundColor, terms } = props
  return (
    <div className='MatchingTerms'>
      <strong>
        <p>Matching Term(s): </p>
      </strong>
      <div className='MatchingTerms-content'>
        {terms.map((term) => (
          <div className='MatchingTerms-term' style={{ backgroundColor }}>
            <p>{term}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MatchingTerms
